<template>
    <line-chart ref="lineChart"
                v-bind="$attrs"
                :data="localeData"
                enable-resize="vertical"
                :loading="loading">
        <slot></slot>
    </line-chart>
</template>

<script>
import LineChart from "@/components/LayoutMaps/openLayers/stuff/LineChart";

export default {
    name: "AutoLineChart",
    components: {LineChart},
    props: {
        queryApi: String,
        queryBody: {
            type: Object,
            default: () => {
            }
        },
        dataFormatter: {
            type: Function,
            default: (response, data) => {
                return data;
            }
        },
        xAxisFormatter: {
            type: Function,
            default: () => {
                return [];
            }
        },
        intervalSecs: {
            type: Number,
            default: 2500
        }
    },
    watch: {
        queryApi() {
            this.queryChanged = true;
        },
        queryBody: {
            handler() {
                this.queryChanged = true;
            },
            deep: true,
        }
    },
    data() {
        return {
            localeData: {},
            xAxis: [],
            loading: true,

            interval: null,
            queryChanged: false,

            waitingQueryFinish: false,
        }
    },
    mounted() {
        this.getRemoteData();
        this.interval = setInterval(this.getRemoteData, this.intervalSecs,);
    },
    methods: {
        getRemoteData() {
            if (this.queryApi) {
                if (this.waitingQueryFinish) {
                    return;
                }
                if (this.queryChanged) {
                    this.loading = true;
                }
                this.waitingQueryFinish = true;
                this.$store.dispatch('api/post', {
                    url: this.queryApi,
                    data: this.queryBody,
                    consoleLog: this.loading
                }).then(response => {
                    this.localeData = this.dataFormatter(response);
                    this.xAxis = this.xAxisFormatter(response);
                    this.queryChanged = false;
                }).finally(() => {
                    this.loading = false;
                    this.waitingQueryFinish = false;
                });
            }
        },

        resizeChart() {
            this.$refs.lineChart.resizeChart();
        },
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}
</script>

<style scoped>

</style>
